<script setup lang="ts">
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useScrollVideo } from '@/composables/useScrollVideo';
import { useHeaderIntersection } from '@/composables/useHeaderIntersection';

gsap.registerPlugin(ScrollTrigger);

const wrapperRef = ref<HTMLElement | null>(null);
const canvasRef = ref<HTMLCanvasElement | null>(null);

useScrollVideo(wrapperRef, canvasRef, 74);
useHeaderIntersection(wrapperRef);

const scrollAnimation = () => {
  const timeline = gsap.timeline({
    duration: 1,
    scrollTrigger: {
      trigger: wrapperRef.value,
      start: 'top bottom',
      end: 'bottom bottom',
      scrub: 0.4,
    },
  });

  gsap.set(canvasRef.value, {
    scale: 0.25,
    borderRadius: '2rem',
  });
  timeline.to(
    canvasRef.value,
    {
      scale: 1,
      borderRadius: '0',
      duration: 0.525,
    },
    0,
  );
  timeline.add(() => {
    document.documentElement.setAttribute('data-experience', 'ready');
  });
  timeline.to(
    canvasRef.value,
    {
      opacity: 0,
      duration: 0.08,
    },
    0.96,
  );
  timeline.add(() => {
    document.documentElement.setAttribute('data-experience', 'running');
  });
};

onMounted(() => {
  scrollAnimation();
});
</script>

<template>
  <div ref="wrapperRef" class="content-intro3d">
    <canvas ref="canvasRef" class="canvas" />
  </div>
</template>

<style scoped>
.content-intro3d {
  padding: 0 !important;
  height: 200vh;
  /* +5vh to account for the transition duration */
  margin-bottom: -110vh;
  z-index: 1;
  pointer-events: none;
}

.content-intro3d > .canvas {
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
}
</style>
